import React from "react";
import { PageNewState, PartnerDetailPageInitialState } from ".";

export const PartnerDetailPageContext = React.createContext({
  pageState: PartnerDetailPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
